import { render, staticRenderFns } from "./CatalogCreate.vue?vue&type=template&id=3101387f&scoped=true&"
import script from "./CatalogCreate.vue?vue&type=script&lang=js&"
export * from "./CatalogCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3101387f",
  null
  
)

export default component.exports